export default "__VITE_ASSET__606c4304__"